import { gql } from '__generated__';

export default gql(`
  mutation DeleteInvitation($id: ID!) {
    deleteInvitation(id: $id)
  }
`);
